import React from "react";
import Layout from "../../../../Components/Layout";
import CheckoutSuccess from "../../../../Components/User/Events/Checkout/CheckoutSuccess";

const OrderSuccessPage = () => {
  return (
    <Layout Sidebar={0} ExtraclassName="event-thanks-panel">
      <CheckoutSuccess />
    </Layout>
  );
};

export default OrderSuccessPage;
